/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { CountAdjSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const countAdjSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const countAdjSync01FetchCountAdjSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const countAdjSync01FetchCountAdjSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const countAdjSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const countAdjSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const countAdjSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const countAdjSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const countAdjSync01SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_RESET_TIMESTAMP]: countAdjSync01ResetTimestamp,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_FETCH_COUNT_ADJ_SYNC01_LOADING]: countAdjSync01FetchCountAdjSync01Loading,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_FETCH_COUNT_ADJ_SYNC01_SUCCESS]: countAdjSync01FetchCountAdjSync01Success,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_ADD_SELECTED_DOCUMENTS]: countAdjSync01AddSelectedDocuments,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_REMOVE_SELECTED_DOCUMENTS]: countAdjSync01RemoveSelectedDocuments,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_SET_WORKSPACE_VISIBLE]: countAdjSync01SetWorkspaceVisible,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_SYNC_LOADING]: countAdjSync01SyncLoading,
  [CountAdjSync01Types.COUNT_ADJ_SYNC01_SYNC_NOW_SUCCESS]: countAdjSync01SyncNowSuccess
});
